  <div *ngIf="isLoading === true" class="d-flex justify-content-center p-2">
    Loading...&nbsp;<span class="spinner-border spinner-border-sm"></span>
  </div>
  <ng-content *ngIf="isLoading === false"></ng-content>